<a
  #backToTopButton
  role="button"
  class="btn-scroll-top"
  data-scroll
  (click)="scrollToTop()"
>
  <span class="btn-scroll-top-tooltip text-muted fs-sm me-2">Top</span>
  <i class="btn-scroll-top-icon bx bx-chevron-up"></i>
</a>
